import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useTenantAuth } from "@/context/TenantAuthContext";
import { PortalProvider } from "@/context/PortalContext";
import { useI18n } from "@/context/I18nContext";
import { LanguageSelect } from "@/components/LanguageSelect";
import { LayoutDashboard, FileText, Receipt, Wrench, FolderOpen, MessageSquare, LogOut, User } from "lucide-react";

const TABS = [
  { to: "/tenant", label: "ダッシュボード", icon: LayoutDashboard, end: true },
  { to: "/tenant/profile", label: "プロフィール", icon: User },
  { to: "/tenant/contracts", label: "契約・電子契約", icon: FileText },
  { to: "/tenant/invoices", label: "家賃・お支払い", icon: Receipt },
  { to: "/tenant/repairs", label: "修繕・不具合", icon: Wrench },
  { to: "/tenant/documents", label: "書類", icon: FolderOpen },
  { to: "/tenant/contact", label: "お問い合わせ", icon: MessageSquare },
];

export default function TenantLayout() {
  const { tenant, logout } = useTenantAuth();
  const { t } = useI18n();
  const navigate = useNavigate();
  const doLogout = async () => { await logout(); navigate("/tenant/login", { replace: true }); };

  return (
    <div className="min-h-screen bg-[#0d0d0d] text-white" data-testid="tenant-layout">
      <header className="bg-[#111111] border-b border-white/10 sticky top-0 z-30">
        <div className="max-w-5xl mx-auto px-4 h-14 flex items-center justify-between">
          <div className="flex items-center gap-2.5">
            <img src="/logo.png" alt="Neo Real Estate Management SaaS" className="h-9 w-auto object-contain bg-white rounded-md p-1 shrink-0" />
            <div className="leading-tight">
              <div className="text-sm font-semibold">{t("借主ポータル")}</div>
              <div className="text-[11px] text-gray-500">{tenant?.name} 様</div>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <LanguageSelect variant="dark" />
            <button onClick={doLogout} className="text-sm text-gray-400 hover:text-white inline-flex items-center gap-1.5" data-testid="tenant-logout">
              <LogOut className="w-4 h-4" />{t("ログアウト")}
            </button>
          </div>
        </div>
        <nav className="max-w-5xl mx-auto px-2 flex gap-1 overflow-x-auto">
          {TABS.map((tb) => (
            <NavLink key={tb.to} to={tb.to} end={tb.end}
              className={({ isActive }) => `flex items-center gap-1.5 px-3 py-2.5 text-sm whitespace-nowrap border-b-2 transition-colors ${
                isActive ? "border-brand text-white" : "border-transparent text-gray-400 hover:text-white"}`}
              data-testid={`tenant-tab-${tb.to}`}>
              <tb.icon className="w-4 h-4" />{t(tb.label)}
            </NavLink>
          ))}
        </nav>
      </header>
      <main className="max-w-5xl mx-auto px-4 py-6">
        <PortalProvider value="/tenant"><Outlet /></PortalProvider>
      </main>
    </div>
  );
}
